import { ADVANCED_FILTERS_TRIGGER_ID } from './AdvancedFilters'

// Two ways to render the Advanced Filters trigger: the full "Advanced Filters"
// label (Incidents + Task Management, where the button has more room and the
// wording earns its keep) and a compact icon-only variant with just an applied
// count (everywhere else -- TPA/claim listing pages where header space is tight).
function AdvancedFiltersTrigger({ count, onClick, compact = false }) {
    if (compact) {
        return (
            <a
                id={ADVANCED_FILTERS_TRIGGER_ID}
                className="driver-list-button advanced-filters-trigger--compact"
                onClick={onClick}
                title="Advanced Filters"
            >
                <i className="fa fa-sliders" aria-hidden="true"></i> | {count}
            </a>
        )
    }

    return (
        <a
            id={ADVANCED_FILTERS_TRIGGER_ID}
            className="driver-list-button"
            onClick={onClick}
            style={{ whiteSpace: 'nowrap' }}
        >
            Advanced Filters | <i className="fa fa-sliders" aria-hidden="true"></i> {count}
        </a>
    )
}

export default AdvancedFiltersTrigger
